<template>
    <b-container fluid class="overview">
        <h1 class="text-left">{{ $t('urlConnectionLicenses') }}</h1>
        <br />
        <div class="row">
            <!-- Search field -->
            <search-box
                id="searchConnectionLisences"
                @input="$_onInput"
                :info="$t('searchInfo')"
                :autofocus="true"
                :value="searchText"
                :saveInState="true"
            >
                :value="searchText" :saveInState="true"
            </search-box>
            <b-link class="px-1 pt-2" @click="$_clearFilters()">
                {{ $t('clearFilter') }}
            </b-link>
        </div>
        <!-- Overview Table -->
        <div>
            <b-table
                striped
                hover
                small
                outlined
                bordered
                v-show="dataLoaded"
                @row-clicked="$_onDetails"
                :tbody-tr-class="$_rowClass"
                :items="filteredRecords"
                :fields="fields"
                :sort-by.sync="sortBy"
                sort-icon-left
            >
                <!-- Image -->
                <template v-slot:cell(imageData)="data">
                    <b-img
                        :src="data.item.imageData"
                        fluid
                        alt="No icon"
                    ></b-img>
                </template>
            </b-table>
        </div>
        <!-- No content for overview -->
        <div v-show="noData" class="col-md-12">
            <span>{{ $t('organizationNonePresent') }}</span>
        </div>
        <router-links-footer
            :routerLinks="[{ name: 'urlConnectionLicensesNew' }]"
        />
    </b-container>
</template>

<script>
    import { orderBy } from 'lodash';
    import { arrayNotEmpty, nprogress } from '../../services/utilities';
    import { URL_CONNECTION_TYPE } from '../../constants';
    import SearchBox from '../../components/SearchBox.vue';
    import RouterLinksFooter from '../../components/dashboard/RouterLinksFooter.vue';

    export default {
        name: 'UrlConnectionLicensesOverview',

        components: {
            'search-box': SearchBox,
            'router-links-footer': RouterLinksFooter
        },

        data: function () {
            return {
                fields: [
                    {
                        key: 'type',
                        label: this.$t('columnTypeTitle'),
                        sortable: true,
                        class: 'text-left',
                        thStyle: { border: 0 },
                        formatter: (value) => {
                            if (value === URL_CONNECTION_TYPE.StreetView) {
                                return this.$t('streetView');
                            } else if (value === URL_CONNECTION_TYPE.Others) {
                                return this.$t('others');
                            } else {
                                return '-';
                            }
                        }
                    },
                    {
                        key: 'name',
                        label: this.$t('columnNameName'),
                        sortable: true,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'url',
                        label: this.$t('columnUriTitle'),
                        sortable: true,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'imageData',
                        label: 'Bitmap',
                        sortable: false,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    }
                ],
                sortBy: 'type',
                connectionLicenses: [],
                searchText: '',
                isResolved: false
            };
        },

        computed: {
            dataLoaded() {
                return this.connectionLicenses.length > 0;
            },

            noData() {
                return (
                    this.isResolved &&
                    this.connectionLicenses &&
                    this.connectionLicenses.length === 0
                );
            },

            filteredRecords() {
                let records = this.connectionLicenses;
                // filter records on NAME
                if (this.searchText && this.searchText.length > 0) {
                    const tokens = this.searchText.toLowerCase();
                    records = records.filter((record) => {
                        return record.name.toLowerCase().includes(tokens);
                    });
                }
                return orderBy(records, [(o) => o.name.toLowerCase()]);
            }
        },

        async created() {
            nprogress.start();
            const result = await this.$store.dispatch('useApiData', {
                name: 'GetAllUrlConnectionLicenses'
            });
            this.connectionLicenses = result?.data;
            this.$_convertImageData();
            this.isResolved = true;
            nprogress.done();
        },

        methods: {
            /*
             * Decode image data from base64 encoded string
             */
            $_convertImageData() {
                if (arrayNotEmpty(this.connectionLicenses)) {
                    this.connectionLicenses.forEach((link) => {
                        link.imageData =
                            link.imageData.length > 0
                                ? Buffer.from(link.imageData, 'base64').toString()
                                : null;
                    });
                }
            },

            $_onDetails(record) {
                this.$router.push({
                    path: `/dashboard/connectionLicense/detail/${record.id}`
                });
            },

            $_onInput(searchText) {
                this.searchText = searchText;
            },

            $_rowClass() {
                return 'tablerow';
            },

            $_clearFilters() {
                this.$_onInput('');
            }
        }
    };
</script>
<style scoped>
.img-fluid {
    max-width: 100px !important;
    max-height: 35px !important;
}
</style>
